import { DataError, Either, UseCase } from '@robotrader/core-lib';

import {
  TradingSignal,
  TradingSignalRepository,
  TrailingStopV1UseCaseProps,
} from '@/modules/trader/domain';

interface GetTrailingStopV1SimulationUseCaseProps {
  tradingSignalRepository: TradingSignalRepository;
}

export class GetTrailingStopV1SimulationUseCase
  implements
    UseCase<TrailingStopV1UseCaseProps, Either<DataError, TradingSignal[]>>
{
  private tradingSignalRepository: TradingSignalRepository;

  constructor({
    tradingSignalRepository,
  }: GetTrailingStopV1SimulationUseCaseProps) {
    this.tradingSignalRepository = tradingSignalRepository;
  }

  execute(
    props: TrailingStopV1UseCaseProps,
  ): Promise<Either<DataError, TradingSignal[]>> {
    return this.tradingSignalRepository.simulateTrailingStopV1(props);
  }
}
